// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"9ecdb14f","53":"6f5e1747","78":"b52be82a","169":"83a1888b","227":"c72cec31","488":"29b71886","735":"5353191f"}[chunkId] + ".chunk.js";
};